import styles from "./ViewSuperUser.module.css";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Button, Chip } from "@mui/material";
import dayjs from "dayjs";
import api_endpoints from "../../api";
import LoadingContainer from "../LoadingContainer/LoadingContainer";
import { getPageFromName } from "../../route_utils";
import { useCustomTranslation } from "../../hooks/useCustomTranslation";

const ViewSuperUser = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { id } = useParams();
  const { t } = useCustomTranslation("Super utilisateurs");

  const superUserId = state?.super_user_id || id;

  const [loading, setLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(false);
  const [superUser, setSuperUser] = useState(null);

  useEffect(() => {
    if (!superUserId) {
      setLoading(false);
      setLoadingError(true);
      return;
    }

    fetchSuperUser();
  }, [superUserId]);

  const fetchSuperUser = async () => {
    setLoading(true);
    setLoadingError(false);

    try {
      const response = await api_endpoints.getSuperUserById(superUserId);

      if (response.status === 200) {
        setSuperUser(response.data);
      } else {
        setLoadingError(true);
      }
    } catch (error) {
      console.error(error);
      setLoadingError(true);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = () => {
    navigate(
      getPageFromName("Modifier le super utilisateur").path.replace(":id", superUserId),
      {
        state: { super_user_id: superUserId },
      }
    );
  };

  return (
    <LoadingContainer loading={loading} error={loadingError}>
      <div className={styles.main_container}>
        {!superUser?.is_deleted && (
          <div className="flex justify-end">
            <Button variant="contained" onClick={handleEdit}>
              {t("superuser_action_edit")}
            </Button>
          </div>
        )}

        <div className={styles.user_details_container}>
          <div className={styles.section_title}>{t("superuser_view_general_information")}</div>

          <div className={styles.grid}>
            <div className={styles.field_block}>
              <div className={styles.field_label}>{t("superuser_table_firstname")}</div>
              <div>{superUser?.first_name || "-"}</div>
            </div>

            <div className={styles.field_block}>
              <div className={styles.field_label}>{t("superuser_table_lastname")}</div>
              <div>{superUser?.last_name || "-"}</div>
            </div>

            <div className={styles.field_block}>
              <div className={styles.field_label}>{t("superuser_table_email")}</div>
              <div>{superUser?.email || "-"}</div>
            </div>

            <div className={styles.field_block}>
              <div className={styles.field_label}>{t("superuser_view_creation_date")}</div>
              <div>
                {superUser?.created_at
                  ? dayjs(superUser.created_at).format("YYYY-MM-DD")
                  : "-"}
              </div>
            </div>

            <div className={styles.field_block}>
              <div className={styles.field_label}>{t("superuser_table_status")}</div>
              <div>
                <Chip
                  label={
                    superUser?.is_active
                      ? t("superuser_table_active")
                      : t("superuser_table_not_active")
                  }
                  color={superUser?.is_active ? "success" : "error"}
                  variant="filled"
                />
              </div>
            </div>

            <div className={styles.field_block}>
              <div className={styles.field_label}>{t("superuser_view_verified")}</div>
              <div>
                <Chip
                  label={
                    superUser?.is_verified
                      ? t("superuser_table_yes_option")
                      : t("superuser_table_no_option")
                  }
                  color={superUser?.is_verified ? "success" : "error"}
                  variant="filled"
                />
              </div>
            </div>

            <div className={styles.field_block}>
              <div className={styles.field_label}>{t("superuser_view_deleted")}</div>
              <div>
                <Chip
                  label={
                    superUser?.is_deleted
                      ? t("superuser_table_yes_option")
                      : t("superuser_table_no_option")
                  }
                  color={superUser?.is_deleted ? "error" : "success"}
                  variant="filled"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadingContainer>
  );
};

export default ViewSuperUser;
